export default __webpack_public_path__ + "static/media/hackaproject.6364e892.png";